// extracted by mini-css-extract-plugin
export default {"ImageGrid":"ImageGrid_ImageGrid__z0D0X","gridImage":"ImageGrid_gridImage__yuG7U","singleImage":"ImageGrid_singleImage__Kks0m"};